import { gql } from "@apollo/client";

export const getLensDiscoverabilityTagCandidates = gql`
    query getLensDiscoverabilityTagCandidates($lensId: ID!) {
        getLensDiscoverabilityVisualTagCandidates(input: { lensId: $lensId }) {
            visualTagsList
        }
        getLensDiscoverabilityLocationTagCandidates(input: { lensId: $lensId }) {
            locationTagsList
        }
        getLensDiscoverabilityTimeTagCandidates(input: { lensId: $lensId }) {
            timeTagsList
        }
    }
`;
